import '../CsvJsonInfoPages.scss';


function NewPriceAndOptions() {

    const data = [
        { field: 1, description: 'Option Total' },
        { field: 2, description: 'CAP Vehicle Code' },
        { field: 3, description: 'CAP Vehicle Identification Number' },
        { field: 4, description: 'Basic Vehicle Price (##########.####)' },
        { field: 5, description: 'VAT (#########.####)' },
        { field: 6, description: 'Total Vehicle Price (##########.####)' },
        { field: 7, description: 'Vehicle Price / Delivery Price Effective From Date (ddmmyyyy)' },
        { field: 8, description: 'Actual Date of Last Option Price Change (ddmmyyyy)' },
        { field: 9, description: 'Option 1 Code' },
        { field: 10, description: 'Option 1 Type (see below for description)' },
        { field: 11, description: 'Option 1 Basic Price (##########.####)' },
        { field: 12, description: 'Option 1 VAT (#########.####)' },
        { field: 13, description: 'Option 1 Total Option Price (##########.####)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data - New Price & Options</h1>
            <p>Provides vehicle new price and selectable options with prices for current vehicles.<br/><br/>
                <b>File Naming Convention</b><br/><br/><br/>
                The &lt;FILENAME&gt; is dependant on the product being produced as follows.
            </p>

            <b>New Vehicle Prices</b>
            <p>CPRNEW.??? CARS<br />
                LPRNEW.??? LIGHT COMMERCIALS<br />
                BPRNEW.??? BIKES<br />
                HPRNEW.??? HEAVIES
            </p>

            <b>Standard Equipment Prices</b>
            <p>CPREQU.??? CARS<br />
                LPREQU.??? LIGHT COMMERCIALS<br /><br />

                The 3 question marks (???) on each of the above files will be replaced with the day i.e. J12 for January 12th.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <b>New Prices Option Types </b>
            <p>A = On The Road<br />
                B = Driver Convenience<br />
                C = Entertainment<br />
                D = Exterior Features<br />
                E = Interior Features<br />
                F = Paintwork<br />
                G = Trim<br />
                H = Safety<br />
                I = Security<br />
                J = Wheels<br />
                K = Packs<br />
                L = Technical<br />
                M = Warranty<br /><br />

                Negative cost option shown as a minus (-999.99) value<br />
                No cost options shown with zero (0.00) value
            </p>

            <b>New Prices Option Types (OLD TYPE CODES)</b>
            <p>Discontinued codes from September 2003<br/>
                O = Option<br/>
                S = Standard<br/>
                C = No Cost Option<br/>
                X = Negative Cost Option<br/>
                N = Delivery
            </p>
        </div>
    );
}

export default NewPriceAndOptions;
